/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/Vin.yaml
import { ScanbotVinImpl } from './impl';
/**
 * Entry point for all VIN scanning features.
 */
export const ScanbotVin = {
    /**
     * Opens the Ready-To-Use UI VIN scanner with the desired configuration.
     * @param {VinScannerScreenConfiguration} configuration - The VIN scanner configuration to be used for scanning.
     * @returns {Promise<ResultWrapper<VinScannerUiResult>>} - The result of the VIN scanning operation.
     */
    async startScanner(configuration) {
        return ScanbotVinImpl.startScanner(configuration);
    },
    /**
     * Forces the Ready-To-Use UI VIN scanner to close if it is currently open.
     * @returns {Promise<void>}
     */
    async forceCloseScanner() {
        return ScanbotVinImpl.forceCloseScanner();
    },
};
//# sourceMappingURL=Vin.js.map